// extracted by mini-css-extract-plugin
module.exports = {"container":"skeleton_container__jSo6h","skeleton_animate":"skeleton_skeleton_animate__BaWgt","loading-roller":"skeleton_loading-roller__dK5NI"};